import { RequestAnalyticsIdType } from '@fullstory/proto/fs/services/alexa';
import { useEffect, useRef } from 'react';
import { getRequestAnalytics } from '@fullstory/util/alexa-request-analytics';
import { isEqual } from 'lodash';

export const useRequestAnalytics = (
  id?: string,
  isSaved: boolean = false,
  type: RequestAnalyticsIdType = RequestAnalyticsIdType.INVALID,
) => {
  const requestAnalytics = useRef(getRequestAnalytics(type, isSaved, id));

  useEffect(() => {
    const newRequest = getRequestAnalytics(type, isSaved, id);
    if (!isEqual(requestAnalytics.current, newRequest)) {
      requestAnalytics.current = newRequest;
    }
  }, [id, isSaved, type]);

  return requestAnalytics.current;
};
